import { useQuery } from "@tanstack/react-query";

import { getPulseMetadata } from "@app/analytics/Pulse/api";
import { useAuthenticated } from "@app/common/auth/useAuth";
import { hasRetryableStatus } from "@app/common/utils";

const ONE_HOUR = 60 * 60 * 1000;

const usePulseMetadataQuery = (
  { enabled }: { enabled: boolean } = { enabled: true }
) => {
  const { user } = useAuthenticated();

  return useQuery({
    queryKey: ["pulseMetadata", user.id],
    queryFn: getPulseMetadata,
    enabled: Boolean(user) && enabled,
    refetchOnWindowFocus: false,
    staleTime: ONE_HOUR,
    retry: (failureCount, error) =>
      failureCount < 3 && hasRetryableStatus(error),
  });
};

export default usePulseMetadataQuery;
